<app-modal>
  <app-modal-title>{{ (isEditMode ? 'modal.edit-project.title.edit' : 'modal.edit-project.title.create') | translate }}</app-modal-title>
  <app-modal-body>
    <div class="-mx-6" [formGroup]="form">
      <p class="text-sm text-error-500" *ngIf="error">{{ 'modal.edit-project.error' | translate}}</p>

      <app-form-group label="{{ 'modal.edit-project.input.name' | translate }}">
        <app-input formControlName="name" placeholder="{{ 'modal.edit-project.input.name.placeholder' | translate }}"></app-input>
      </app-form-group>
      <app-form-group label="{{ 'modal.edit-project.input.description' | translate }}">
        <app-textarea formControlName="description" placeholder="{{ 'modal.edit-project.input.description.placeholder' | translate }}"></app-textarea>
      </app-form-group>
      <app-form-group label="{{ 'modal.edit-project.input.customer' | translate }}">
        <app-input formControlName="customer" placeholder="{{ 'modal.edit-project.input.customer.placeholder' | translate }}"></app-input>
      </app-form-group>
      <app-form-group label="{{ 'modal.edit-project.input.external-id' | translate }}">
        <app-input formControlName="externalId" placeholder="{{ 'modal.edit-project.input.external-id.placeholder' | translate }}"></app-input>

        <p *ngIf="(externalIdExists$ | async) === true" class="text-sm text-red-500">{{ 'modal.edit-project.external-id-exists' | translate}}</p>
      </app-form-group>
      <app-form-group label="{{ 'modal.edit-project.input.status' | translate }}">
        <app-select formControlName="status" [options]="statusOptions" label="{{ 'modal.edit-project.input.status.placeholder' | translate }}"></app-select>
      </app-form-group>
    </div>
  </app-modal-body>
  <app-modal-footer>
    <app-button text="{{ 'modal.edit-project.cancel' | translate }}" variant="plain" (click)="close()"></app-button>
    <app-button text="{{ 'modal.edit-project.save' | translate }}" [loading]="loading || loadingExternalIdCheck" (click)="save()"></app-button>
  </app-modal-footer>
</app-modal>
